/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Pharmacy from './pharmacy';
import PharmacyDetail from './pharmacy-detail';
import PharmacyUpdate from './pharmacy-update';
import PharmacyDeleteDialog from './pharmacy-delete-dialog';

const PharmacyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Pharmacy />} />
    <Route path="new" element={<PharmacyUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyDetail />} />
      <Route path="edit" element={<PharmacyUpdate />} />
      <Route path="delete" element={<PharmacyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyRoutes;
